import * as m from "@paraglide/messages"
import type { ContactFormData, InquirySelectionProps } from "@site-types/sendMail"
import type { UseFormSetValue } from "react-hook-form"
import { FormSelect } from "../FormSelect"
import { useSendMailLang } from "../langContext"

export const InquirySelection = ({ setValue, value }: InquirySelectionProps) => {
  const lang = useSendMailLang()

  const handleChange = (next: string) => {
    resetContactInquiryValues(setValue, next)
  }

  const options = [
    m.contact_formType_options_generalEnquiry({}, { locale: lang }),
    m.contact_formType_options_recruitment({}, { locale: lang }),
    m.contact_formType_options_salesProposals({}, { locale: lang }),
    m.contact_formType_options_mediaEnquiry({}, { locale: lang }),
    m.contact_formType_options_sponsorship({}, { locale: lang }),
  ]

  return (
    <div className="relative mb-8 flex flex-col">
      <label
        className="py-4"
        htmlFor="form-type-list"
      >
        {m.contact_formType_label({}, { locale: lang })} {m.contact_form_required({}, { locale: lang })}
      </label>
      <FormSelect
        id="form-type-list"
        name="type"
        value={value}
        onValueChange={handleChange}
        options={options}
        required
      />
    </div>
  )
}

export function resetContactInquiryValues(setValue: UseFormSetValue<ContactFormData>, next: string) {
  setValue("type", next, { shouldValidate: true, shouldDirty: true })
  setValue("name", "", { shouldValidate: true })
  setValue("email", "", { shouldValidate: true })
  setValue("companyname", "", { shouldValidate: true })
  setValue("phonenumber", "", { shouldValidate: true })
  setValue("message", "", { shouldValidate: true })
  setValue("purpose", "", { shouldValidate: true })
  setValue("position", "", { shouldValidate: true })
  setValue("formSponsorshipStartDate", "", { shouldValidate: true })
  setValue("attachments", [], { shouldValidate: true })
}
